export default __webpack_public_path__ + "static/media/group.c4e27dfa.jpeg";